export enum PopupType {
  LOGIN = 'popup_login',
  REAL_EXPERT_HELP = 'js_real_expert_help_popup',
  UPGRADE_FROM_TRIAL = 'js_upgrade_from_trial_popup',
  UPGRADE_FROM_TRIAL_PAYMENT_FAILED_ES39123 = 'js_upgrade_from_trial_payment_failed_popup_es39123',
  AI_EXPERT_ORDER_UPGRADE_ES37823 = 'js_ai_expert_order_upgrade_es37823',
  AI_TOOLS_THANKYOU = 'ai_tools_thankyou_popup',
}
